module.exports = "#termsUpdatedModal .modal-dialog {\n  max-width: 560px; }\n  #termsUpdatedModal .modal-dialog .modal-body {\n    padding: 10px 15px; }\n  #termsUpdatedModal .modal-dialog p {\n    line-height: 1.7; }\n  #termsUpdatedModal .modal-dialog a {\n    text-decoration: underline; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/terms-updated-modal/terms-updated-modal.scss
// module id = ./web/modern/components/common/terms-updated-modal/terms-updated-modal.scss
// module chunks = 0